import { supabase } from '@/lib/supabase';

/**
 * Συγκεντρώνει ΟΛΑ τα προσωπικά δεδομένα του χρήστη (δικαίωμα φορητότητας GDPR).
 * Επιστρέφει ένα αντικείμενο έτοιμο για εξαγωγή ως JSON.
 */
export async function gatherMyData(userId: string): Promise<Record<string, unknown>> {
  const [profile, agreements, payments, reviews, wallet, verifications, messages, disputeStatements, sentReports, blocks] = await Promise.all([
    supabase.from('profiles').select('*').eq('id', userId).maybeSingle(),
    supabase
      .from('agreements')
      .select('*')
      .or(`creator_id.eq.${userId},counterparty_id.eq.${userId}`),
    supabase.from('payments').select('*').eq('user_id', userId),
    supabase.from('reviews').select('*').or(`reviewer_id.eq.${userId},reviewee_id.eq.${userId}`),
    supabase.from('wallet_transactions').select('*').eq('user_id', userId),
    supabase.from('verification_requests').select('*').eq('user_id', userId),
    supabase.from('agreement_messages').select('*').eq('sender_id', userId),
    supabase.from('dispute_statements').select('*').eq('user_id', userId),
    supabase.from('chat_reports').select('*').eq('reporter_id', userId),
    supabase.from('blocked_users').select('*').eq('blocker_id', userId),
  ]);

  return {
    exported_at: new Date().toISOString(),
    user_id: userId,
    profile: profile.data ?? null,
    agreements: agreements.data ?? [],
    payments: payments.data ?? [],
    reviews: reviews.data ?? [],
    wallet_transactions: wallet.data ?? [],
    verification_requests: verifications.data ?? [],
    agreement_messages: messages.data ?? [],
    dispute_statements: disputeStatements.data ?? [],
    chat_reports_filed: sentReports.data ?? [],
    blocked_users: blocks.data ?? [],
  };
}
